import axios from 'axios';
import './axiosInterceptor';
// const baseurl = "https://devlogin.telco.com.ar/usuarios/usuario"
export const AUTHENTICATION = process.env.VUE_APP_URLAUTHENTICATION;
export const Perfil = {
  actualizar_contraseña(params) {
    return axios.post(AUTHENTICATION + "/users/change-pass", params)
  },
}
